<template>
    <div class="tags is-marginless">
        <span
            v-for="tag in tags"
            :key="tag"
            :class="[isActive(tag) ? 'is-light' : 'is-link']"
            class="tag"
            @click="toggleTag(tag)"
            >{{ tag }}</span
        >
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    model: {
        prop: 'selectedTags',
    },

    props: {
        tags: {
            type: Array,
            default: () => {
                return [];
            },
        },
        selectedTags: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            activeTags: [...this.selectedTags],
        };
    },
    computed: {
        isActive() {
            return function (tag) {
                return _.contains(this.selectedTags, tag);
            };
        },
    },
    watch: {
        selectedTags: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.activeTags = val;
                }
            },
        },
    },
    methods: {
        toggleTag(tag) {
            if (_.contains(this.selectedTags, tag)) {
                this.activeTags = _.without(this.activeTags, tag);
            } else {
                this.activeTags.push(tag);
            }
            this.$emit('input', this.activeTags);
        },
    },
};
</script>

<style scoped>
.tags {
    padding-top: 0.5rem;
}
.tags .tag:first-child {
    margin-left: 0;
}
.tag {
    cursor: pointer;
}
</style>
